export default __webpack_public_path__ + "static/media/flag_ko.e814d54a.svg";